import React, { useEffect, useState } from "react";
import CourseCard from "./CourseCard";
import { useDispatch, useSelector } from "react-redux";
import { getCoursesAction } from "../redux/actions/courseAction";
import { Toaster, toast } from "react-hot-toast";
import sitedata from "../sitedetails.json";
import CourseShimmer from "./course/CourseShimmer";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "./ErrorFallback";
//import Navbar from "./Navbar";
const Courses = () => {
  const dispatch = useDispatch();
  const { courses, error, message } = useSelector((state) => state.courses);
  const shimmerVar = [
    {
      id: 1,
    },
    {
      id: 2,
    },
    {
      id: 3,
    },
  ];
  useEffect(() => {
    dispatch(getCoursesAction());

    if (error) {
      toast.error(error);
      dispatch({
        type: "clearError",
      });
    }

    if (message) {
      toast.success(message);
      dispatch({
        type: "clearMessage",
      });
    }
  }, [dispatch, error, message]);

  const coursecategory = sitedata.coursecategory;

  // console.log(courses)

  const [keyword, setKeyword] = useState("");

  // const [filteredCourses, setFilteredCourses] = useState([])

//  const  searchHandler = () => {
//   filterCoursesFunction(keyword, courses)
    
//   }

//   const filterCoursesFunction = (keyword, courses) => {
//     const data = courses.filter( (course) => course.title.toLowerCase().includes(keyword))
//     setFilteredCourses(data)

//   }
  return (
    <>
      <Toaster />
      {/* <Navbar/> */}
      <div className="w-full h-full">
        {/* max-w-[1512px] */}
        <div className=" font-outfit bg-brand_nero text-white p-7   items-center">
          <div className="h-full lg:px-[200px]">
            <div className="text-center">
              <h4 className=" font-outfit font-medium text-3xl my-2 py-4">
                COURSES
              </h4>

              <input
                className="text-black px-6 py-2 lg:w-[600px]"
                value={keyword}
                placeholder="Search Courses"
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
              />
              {/* <button className="bg-white px-3 py-2 text-black mx-2" onClick={(e) => {
                  // searchHandler()
                }} >Search</button> */}
              <span className="flex overflow-auto w-auto lg:max-w-[700px] mx-auto justify-between my-4 ">
                {coursecategory.map((item) => (
                  <button
                    onClick={() => {
                      setKeyword(item);
                    }}
                    key={item}
                  >
                    <p
                      key={item}
                      className="py-1 px-3 mx-5  text-black  bg-stone-200"
                    >
                      {item}
                    </p>
                  </button>
                ))}
              </span>
            </div>
                    <ErrorBoundary FallbackComponent={ErrorFallback}>
                    <div className="my-12 w-full">
              {courses ? courses.filter( (item) => {

                return keyword.toLowerCase() === '' ? item : 
                item.title.toLowerCase().includes(keyword.toLowerCase())
              }).map((course) => (
                    <CourseCard
                      key={course._id}
                      imgSrc={course.poster.url}
                      id={course._id}
                      title={course.title}
                      description={course.description}
                      type={course.category}
                      views={course.views}
                      createdBy={course.createdBy}
                    ></CourseCard>
                  ))
                : shimmerVar.map((i) => ( <div key={i.id}><CourseShimmer /></div>))}

            </div>
                      
                    </ErrorBoundary>
            
          </div>
        </div>
      </div>
    </>
  );
};

export default Courses;
